import * as React from "react";
import { type UploadDestination } from "./uploadCoordinator";
import { type CollectedUploadFile, type UploadDialogState } from "./types";

export interface GlobalUploadContextValue {
  readonly dialogState: UploadDialogState | null;
  readonly openUploadDialog: (destination: UploadDestination) => void;
  readonly openDroppedUpload: (
    files: readonly CollectedUploadFile[],
    destination: UploadDestination,
    collectionMessage?: string,
  ) => void;
  readonly trackDirectoryUploadOperation: (operationId: string) => void;
}

export const GlobalUploadContext = React.createContext<GlobalUploadContextValue | undefined>(undefined);

export const useGlobalUpload = (): GlobalUploadContextValue => {
  const context = React.useContext(GlobalUploadContext);
  if (!context) throw new Error("useGlobalUpload must be used within GlobalUploadProvider");
  return context;
};
